import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Footer, Body, Popup } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentSubscription } from 'features/billing/actions/fetch_current_subscription'
import { resetCreateSubscription } from 'features/billing/create_subscription_slice'
import { humanizePlan } from 'features/billing/helpers'
import { nextPlanIdSelector, billingDateSelector, currentTierSelector } from 'features/billing/selectors'
import { useSmallDateFormat } from 'features/billing/stages/hooks/useDateFormat'

import { reset as resetPromptToRemoveScheduledDowngrade } from './slice'
import { Paragraph } from './styles'

export const FrequencyModal = () => {
  const dispatch = useDispatch()

  const nextPlan = humanizePlan(useSelector(nextPlanIdSelector))
  const nextBillDate = useSmallDateFormat(useSelector(billingDateSelector))
  const oldPlan = useSelector(currentTierSelector)

  const onClose = () => {
    dispatch(resetPromptToRemoveScheduledDowngrade())
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscription())
  }

  return (
    <Popup onClose={onClose}>
      <Header title={I18n.t('publisher.billing.scheduled_downgrade.frequency_prompt_to_remove_modal.title')} />
      <Body>
        <Paragraph>
          {
            I18n.t('publisher.billing.scheduled_downgrade.frequency_prompt_to_remove_modal.text1',
              {
                new_plan: nextPlan,
                billing_date: nextBillDate
              }
            )
          }
        </Paragraph>
        <Paragraph>
          {
            I18n.t('publisher.billing.scheduled_downgrade.frequency_prompt_to_remove_modal.text2',
              {
                old_plan: oldPlan
              }
            )
          }
        </Paragraph>
      </Body>
      <Footer>
        <Button onClick={onClose}>
          {I18n.t('publisher.billing.scheduled_downgrade.frequency_prompt_to_remove_modal.submit')}
        </Button>
      </Footer>
    </Popup>
  )
}
